import { Stack } from "../../../stack";
import { MessageDirection } from "@edgetier/watchtower-types";
import { DayBadge } from "./day-badge";
import { StatusUpdate } from "./status-update";
import { MessagesList } from "./messages-list";
import { Message } from "./message";

/**
 * Displays a loading state for the chat view with skeleton placeholders for day badges, status updates, and messages.
 * @returns {JSX.Element} The LoadingChat component.
 */
const LoadingChat = () => {
    return (
        <Stack align="center" w="100%" justify="flex-start">
            <DayBadge.Skeleton />
            <StatusUpdate.Skeleton />
            <MessagesList direction={MessageDirection.Outbound}>
                <Message.Skeleton direction={MessageDirection.Outbound} />
                <Message.Skeleton direction={MessageDirection.Outbound} />
            </MessagesList>
            <MessagesList direction={MessageDirection.Inbound}>
                <Message.Skeleton direction={MessageDirection.Inbound} />
            </MessagesList>
            <MessagesList direction={MessageDirection.Outbound}>
                <Message.Skeleton direction={MessageDirection.Outbound} />
            </MessagesList>
            <MessagesList direction={MessageDirection.Inbound}>
                <Message.Skeleton direction={MessageDirection.Inbound} />
            </MessagesList>
        </Stack>
    );
};

export { LoadingChat };
